jQuery(document).ready(function($) {

    $('.popup-with-form').magnificPopup({
        type: 'inline',
        preloader: false,
        focus: '#name',

        // When elemened is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#name';
                }
            }
        }
    });

    jQuery(".menu-btn").click(function(){
        if(jQuery('#res_nav_wrap').hasClass('hide')) {
            jQuery('#res_nav_wrap').removeClass('hide');
        } else {
            jQuery('#res_nav_wrap').addClass('hide');
        }
    });

    jQuery("#res_nav_wrap a").click(function(){
        if(jQuery('#res_nav_wrap').hasClass('hide')) {
            jQuery('#res_nav_wrap').removeClass('hide');
        } else {
            jQuery('#res_nav_wrap').addClass('hide');
        }
    });

    jQuery("#res_nav_wrap a").click(function(){
        if(jQuery('.menu-btn').hasClass('position')) {
            jQuery('.menu-btn').removeClass('position');
        } else {
            jQuery('.menu-btn').addClass('position');
        }
    });

    jQuery(".menu-btn").click(function(){
        if(jQuery('.menu-btn').hasClass('position')) {
            jQuery('.menu-btn').removeClass('position');
        } else {
            jQuery('.menu-btn').addClass('position');
        }
    });

    jQuery("#faq_open").click(function(){
        if(jQuery('#accord_wrap').hasClass('open')) {
            jQuery('#accord_wrap').removeClass('open');
        } else {
            jQuery('#accord_wrap').addClass('open');
        }
    });

    jQuery("#faq_open").click(function(){
        if(jQuery('#faq_open i').hasClass('roat')) {
            jQuery('#faq_open i').removeClass('roat');
        } else {
            jQuery('#faq_open i').addClass('roat');
        }
    });

    if( jQuery('#accordion').length ){

        jQuery( "#accordion" ).accordion({
            animate: 300,
            collapsible: true,
            active: false,
            heightStyle: "content"
        });
    }

    jQuery('#horizontalTab').responsiveTabs({
        startCollapsed: true,
        collapsible: true
    });

    function isMobile(){
        return (
            (navigator.userAgent.match(/Android/i)) ||
            (navigator.userAgent.match(/webOS/i)) ||
            (navigator.userAgent.match(/iPhone/i)) ||
            (navigator.userAgent.match(/iPod/i)) ||
            (navigator.userAgent.match(/iPad/i)) ||
            (navigator.userAgent.match(/BlackBerry/))
        );
    }

    function scrollBG() {
        scrollTop = jQuery(this).scrollTop();
        if(scrollTop > 30){
            $('header').addClass('scroll_head');
        }
        else{
            $('header').removeClass('scroll_head');
        }
    }

    FastClick.attach(document.body);

    //clear search on click
    defaultValue = jQuery('#Searchform').val();
    jQuery('#Searchform').click(function() {
        if( this.value == defaultValue ) {
            jQuery(this).val("");
        }
    });

    //to anchor
    $('nav ul li a').click(function (e){
        if(!$(this).parent().hasClass('lang-item')) {
            e.preventDefault();
            var target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top - 150
            }, 1000)
        }
    });

    //clear search on click
    defaultValue = jQuery('#Searchform').val();
    jQuery('#Searchform').click(function() {
        if( this.value == defaultValue ) {
            jQuery(this).val("");
        }
    });

    pozme();
    boxsize();

    if($('html').attr('lang') == 'en-GB') {
        $('.name-label').html('Name');
        $('.mail-label').html('Email');
        $('.message-label').html('Message');
        $('.wpcf7-submit').val('Send');
    }

});

//Page Background resize
jQuery(window).resize(function(){
    pozme();
    boxsize();
});

function pozme(){
    jQuery(".layout_fixed.home").css("min-height", function(){
        return jQuery(window).height();
    });

    return true;
}

function scrollBG() {
    scrollTop = jQuery(this).scrollTop();
    scrollBottom = jQuery(document).height() - jQuery(window).height() - jQuery(window).scrollTop();

    jQuery('.layout_fixed').css({
        'background-position' : 'center ' + (scrollTop * -0.3 )+"px"
    });
}

function isMobile(){
    return (
        (navigator.userAgent.match(/Android/i)) ||
        (navigator.userAgent.match(/webOS/i)) ||
        (navigator.userAgent.match(/iPhone/i)) ||
        (navigator.userAgent.match(/iPod/i)) ||
        (navigator.userAgent.match(/iPad/i)) ||
        (navigator.userAgent.match(/BlackBerry/))
    );
}

function boxsize() {

    var highestBox = 0;
    // console.log(window.outerWidth);

    //reset hieght
    jQuery('.heightresize').each(function(){
        jQuery(this).height('auto');
    });

    // exit if too wide
    if ( jQuery(window).width() < 1036) return;


    jQuery('.heightresize').each(function(){

        if(jQuery(this).height() > highestBox)
            highestBox = jQuery(this).height();

        //console.log(highestBox);
    });

    jQuery('.heightresize').height(highestBox);

    return true;
}